import { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { fetchParentalStatus } from "../redux/ApiSlice/ParentalControlSlice";

// Guards the Neighborhood routes so a teen account can't get in by typing the
// URL, following a stale deep link, or clicking the footer icon before the
// parental-status check resolves — hiding the footer icon alone is cosmetic.
export default function NeighborhoodAccessRoute({ children }) {
    const dispatch = useDispatch();
    const parentalStatus = useSelector((state) => state.ParentalControl.status);
    const parentalStatusLoading = useSelector((state) => state.ParentalControl.statusLoading);
    const parentalStatusError = useSelector((state) => state.ParentalControl.statusError);

    const statusChecked = !!parentalStatus || !!parentalStatusError;
    const neighborhoodAllowed = parentalStatus?.neighborhood_allowed ?? true;

    useEffect(() => {
        if (!statusChecked && !parentalStatusLoading) {
            dispatch(fetchParentalStatus({}));
        }
    }, [statusChecked, parentalStatusLoading, dispatch]);

    useEffect(() => {
        if (statusChecked && !neighborhoodAllowed) {
            toast.error("Neighborhood is turned off by parental controls on this account.");
        }
    }, [statusChecked, neighborhoodAllowed]);

    // Block rendering until we know the status — an account with the setting
    // off should never see the page flash before the redirect fires.
    if (!statusChecked) return null;

    if (!neighborhoodAllowed) return <Navigate to="/" replace />;

    return children || <Outlet />;
}
